import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-9b8c294e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "cms-flex--between mg-b--15"
};
const _hoisted_3 = {
  class: "cms-page-title"
};
const _hoisted_4 = {
  class: "check-film-warp"
};
const _hoisted_5 = {
  class: "left-warp"
};
const _hoisted_6 = {
  class: "cms-card-block"
};
const _hoisted_7 = {
  class: "video-name"
};
const _hoisted_8 = {
  class: "name"
};
const _hoisted_9 = {
  class: "video-list"
};
const _hoisted_10 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_11 = {
  key: 0,
  style: {
    "display": "flex"
  }
};
const _hoisted_12 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_13 = {
  class: "subtitle"
};
const _hoisted_14 = {
  class: "title"
};
const _hoisted_15 = {
  class: "subtitle-list"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "result"
};
const _hoisted_18 = {
  class: "blod"
};
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = {
  class: ""
};
const _hoisted_21 = {
  class: "right-warp"
};
const _hoisted_22 = {
  class: "check-warp cms-card-block"
};
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = {
  style: {
    "margin-bottom": "15px"
  }
};
const _hoisted_25 = {
  key: 1
};
const _hoisted_26 = {
  style: {
    "color": "#222930",
    "font-size": "16px",
    "margin-bottom": "20px"
  }
};
const _hoisted_27 = {
  key: 2
};
const _hoisted_28 = {
  style: {
    "color": "#222930",
    "font-size": "16px",
    "margin-bottom": "20px"
  }
};
const _hoisted_29 = {
  key: 0,
  style: {
    "margin-bottom": "20px"
  }
};
const _hoisted_30 = {
  style: {
    "margin-bottom": "15px"
  }
};
const _hoisted_31 = {
  key: 1,
  class: "flex-sb-center mg-b--20"
};
const _hoisted_32 = {
  style: {
    "color": "#222930",
    "font-size": "16px"
  }
};
const _hoisted_33 = {
  key: 2,
  style: {
    "margin-bottom": "20px"
  }
};
const _hoisted_34 = {
  style: {
    "color": "#222930",
    "font-size": "16px",
    "margin-bottom": "20px"
  }
};
import MediaPlay from '../../../Components/MediaPlay/index.vue';
import Buttons from '@/components/Buttons/index.vue';
import TagType from '../../../FilmReview/components/TagType/index.vue';
import { usePageConfig } from '@/utils/useComponentConfig';
import { useI18n } from 'vue-i18n';
import { elMessage, getTextWidth } from '@/utils';
import { debounce } from '@/utils/tools';
import { inject } from 'vue';
import { getCurrentTime } from '@/utils/timeFormat';
import { handleCopy } from '@/utils/clipboard';
import { RELEASE_COLOR_NEW, RELEASE_STATUS_NEW } from '@/assets/config/dicts';
import { getDramaInfoApi, batchAuditStatusApi, batchReleaseStatusApi, getMovieInfoApi } from '@/api/vodNew';
import { useVodLanguages } from '@/utils/cacheData';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    detailInfo: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['update:modelValue', 'update-list'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const seasonOptions = ref([]);
    const alltvEpisodesList = ref([]); // 接口返回的所有剧集数据

    const Tags = ref([]);
    const mediaList = ref(); // 接口返回所有电影数据

    const tvSeasonMediaList = ref(); // 接口返回的所有剧集数据

    const broadCastList = inject('broadCastList');

    const validatorReason = (rule, value, callback) => {
      if (value && value.trim() == '') {
        return callback(new Error('输入不能为空'));
      }

      callback();
    };

    const languageOptions = ref([]); // 获取所有语言

    const getAllLanguages = async () => {
      const res = await useVodLanguages();
      languageOptions.value = res;
    };

    const resonFormRef = ref();
    const checkTableRef = ref();
    const batchTableRef = ref();
    const mediaPlayRef = ref(null); // 单个审批弹窗

    const dialogConfig = reactive({
      visible: false,
      action: 'online',
      config: {
        title: ''
      },
      confirm: done => {
        const ids = checkTableConfig.data[checkTableConfig.rowSelectIndex].id;

        if (dialogConfig.action === 'offline') {
          resonFormRef.value.validate(valid => {
            if (valid) {
              batchOnlineOrOffline([ids], 'offline', done, dramaOrMovieData.postData.reason.trim());
            }
          });
        } else if (dialogConfig.action === 'online') {
          batchOnlineOrOffline([ids], 'online', done);
        } else if (dialogConfig.action === 'return') {
          batchOperation([ids], 'return', done);
        }
      }
    }); // 批量审批弹窗

    const batchDialogConfig = reactive({
      visible: false,
      action: '',
      config: {
        title: ''
      },
      confirm: done => {
        const ids = selectTableConfig.data.map(item => item.id);

        if (batchDialogConfig.action === 'offline') {
          resonFormRef.value.validate(async valid => {
            if (valid) {
              batchOnlineOrOffline(ids, 'offline', done, dramaOrMovieData.postData.reason.trim());
            }
          });
        } else if (batchDialogConfig.action === 'online') {
          batchOnlineOrOffline(ids, 'online', done);
        } else if (batchDialogConfig.action === 'return') {
          // 退回审核
          batchOperation(ids, 'return', done);
        }
      }
    }); // 退回审核接口调用

    const batchOperation = async (ids, action, done, remark) => {
      try {
        const language = Tags.value.length > 0 && Tags.value[dramaOrMovieData.currentActive].language || '';
        let params = {
          auditStatus: action,
          mediaIdList: ids,
          programType: props.detailInfo.programType,
          remark,
          programId: props.detailInfo.id
        };
        const res = await batchAuditStatusApi(params);

        if (res.code == '0') {
          elMessage('success', '操作成功');
          dialogConfig.visible = false;
          batchDialogConfig.visible = false;

          if (checkTableRef.value) {
            checkTableRef.value.commonTableRef.clearSelection();
          }

          dramaOrMovieData.postData.reason = '';
          dramaOrMovieData.anew = false;
          getTableList();
          setTimeout(() => {
            done();
          }, 500);
        } else {
          done();
        }
      } catch (error) {
        done();
      }
    }; // 上下线审核接口调用


    const batchOnlineOrOffline = async (ids, action, done, remark) => {
      try {
        const language = Tags.value.length > 0 && Tags.value[dramaOrMovieData.currentActive].language || '';
        let params = {
          releaseStatus: action,
          programType: props.detailInfo.programType,
          mediaIdList: ids,
          auditStatus: dramaOrMovieData.ifReturn ? 'return' : undefined,
          remark,
          programId: props.detailInfo.id
        };
        const res = await batchReleaseStatusApi(params);

        if (res.code == '0') {
          elMessage('success', '操作成功');
          batchDialogConfig.visible = false;
          dialogConfig.visible = false;

          if (checkTableRef.value) {
            checkTableRef.value.commonTableRef.clearSelection();
          }

          dramaOrMovieData.postData.reason = '';
          dramaOrMovieData.ifReturn = false;
          dramaOrMovieData.anew = false;
          getTableList();
          setTimeout(() => {
            done();
          }, 500);
        } else {
          done();
        }
      } catch (error) {
        done();
      }
    }; // 格式化分辨率显示文字


    const getRatioType = val => {
      const item = broadCastList.value.filter(item => {
        return item.type === val;
      });
      return item && item[0].broadCastType;
    };

    const back = () => {
      emit('update:modelValue', false);
      emit('update-list');
    }; // tag组件点击事件


    const onTagClick = debounce((item, index) => {
      if (index === dramaOrMovieData.currentActive) return;
      dramaOrMovieData.subtitleList = [];
      tableConfig.data = [];
      dramaOrMovieData.url = '';
      handleDestroyVideo();
      checkTableConfig.rowSelectIndex = 0;
      checkTableConfig.paginationConfig.page = 1;
      tableConfig.rowSelectIndex = 0;
      dramaOrMovieData.currentActive = index;
      checkTableRef.value.commonTableRef.clearSort();
      getTableList(true);
    }, 500);
    const tableConfig = reactive({
      data: [],
      rowSelectIndex: 0,
      isCardBlock: false,
      isShowHeader: false,
      maxHeight: 200,
      headerButtonsList: [{
        label: '上线',
        type: 'primary',
        func: () => {
          dialogConfig.config.title = '上线';
          dialogConfig.action = 'online';
          dialogConfig.visible = true;
        },
        disabled: false,
        controller: btn => {
          btn.disabled = checkTableConfig.data[checkTableConfig.rowSelectIndex].releaseStatus === 'online' ? true : false;
          return true;
        }
      }, {
        label: '下线',
        type: 'danger',
        func: () => {
          dialogConfig.config.title = '下线';
          dialogConfig.action = 'offline';
          dialogConfig.visible = true;
        },
        disabled: false,
        controller: btn => {
          btn.disabled = checkTableConfig.data[checkTableConfig.rowSelectIndex].releaseStatus === 'offline' ? true : false;
          return true;
        }
      }, {
        label: '退回审核',
        type: 'success',
        func: () => {
          dialogConfig.config.title = '退回审核';
          dialogConfig.action = 'return';
          dialogConfig.visible = true;
        },
        disabled: false,
        controller: btn => {
          btn.disabled = checkTableConfig.data[checkTableConfig.rowSelectIndex].releaseStatus === 'online' ? true : false;
          return true;
        }
      }]
    });
    const columnConfig = reactive({
      columnList: [{
        label: '编码标准',
        prop: 'videoCode'
      }, {
        label: '分辨率',
        prop: 'videoResolution' // formatter: (val) => {
        //     if (val) {
        //         return getRatioType(val);
        //     }
        // }

      }, {
        label: 'URL',
        prop: 'playUrl',
        cellSlot: true,
        showOverflowTooltip: false
      }, {
        label: '操作',
        prop: '',
        widgetType: 'buttons',
        buttonsList: [{
          label: '播放',
          func: debounce(row => {
            dramaOrMovieData.url = '';
            dramaOrMovieData.videoWarpLoading = true;
            setTimeout(() => {
              dramaOrMovieData.videoWarpLoading = false;
              dramaOrMovieData.url = row.url;
            }, 200);
            tableConfig.rowSelectIndex = row.index;
          }, 500)
        }]
      }]
    }); // 判断数组每一项的某一个属性的值是否一样

    const hasSameValue = arr => {
      if (arr.length === 0) return false;
      if (arr.length === 1) return true;
      const firstItemState = arr[0].releaseStatus;
      let num = 0;

      for (let i = 1; i < arr.length; i++) {
        if (arr[i].releaseStatus === firstItemState) num++;
      }

      return num === arr.length - 1 ? true : false;
    }; // 右侧table表格配置


    const checkTableConfig = reactive({
      paginationConfig: usePageConfig(),
      rowSelectIndex: 0,
      data: [],
      isCardBlock: false,
      showPageBar: false,
      isShowHeader: false,
      headerButtonsList: [{
        label: '批量退回审核',
        type: 'success',
        func: () => {
          if (selectTableConfig.data.length === 0) {
            return elMessage('warning', '请先勾选需要批量操作的影片');
          }

          if (hasSameValue(selectTableConfig.data)) {
            if (selectTableConfig.data[0].releaseStatus === 1) return elMessage('warning', '请先下线影片');
            batchDialogConfig.config.title = '退回审核';
            batchDialogConfig.visible = true;
            batchDialogConfig.action = 'return';
          } else {
            return elMessage('warning', '请先勾选状态相同的影片');
          }
        },
        disabled: false,
        controller: btn => {
          btn.disabled = hasSameValue(selectTableConfig.data) && selectTableConfig.data[0].releaseStatus === 'online' ? true : false;
          return true;
        }
      }, {
        label: '批量上线',
        type: 'primary',
        func: () => {
          if (selectTableConfig.data.length === 0) {
            return elMessage('warning', '请先勾选需要批量操作的影片');
          }

          if (hasSameValue(selectTableConfig.data)) {
            batchDialogConfig.config.title = '上线';
            batchDialogConfig.visible = true;
            batchDialogConfig.action = 'online';
          } else {
            return elMessage('warning', '请先勾选状态相同的影片');
          }
        },
        disabled: false,
        controller: btn => {
          btn.disabled = hasSameValue(selectTableConfig.data) && selectTableConfig.data[0].releaseStatus === 'online' ? true : false;
          return true;
        }
      }, {
        label: '批量下线',
        type: 'danger',
        func: () => {
          if (selectTableConfig.data.length === 0) {
            return elMessage('warning', '请先勾选需要批量操作的影片');
          }

          if (hasSameValue(selectTableConfig.data)) {
            batchDialogConfig.config.title = '下线';
            batchDialogConfig.visible = true;
            batchDialogConfig.action = 'offline';
          } else {
            return elMessage('warning', '请先勾选状态相同的影片');
          }
        },
        controller: btn => {
          btn.disabled = hasSameValue(selectTableConfig.data) && selectTableConfig.data[0].releaseStatus === 'offline' ? true : false;
          return true;
        }
      }],
      showLoading: false,
      'row-key': 'id'
    });
    const checkColumnConfig = reactive({
      columnList: [{
        label: '',
        type: 'selection',
        'reserve-selection': true
      }, {
        label: '影片名称',
        prop: 'name'
      }, {
        label: '剧集编号',
        prop: 'sequence',
        sortable: 'custom',
        controller: () => {
          return props.detailInfo.programType === 'movie' ? false : true;
        }
      }, {
        label: '上线状态',
        prop: 'releaseStatus',
        cellSlot: true
      }, {
        label: '上传时间',
        prop: 'createTime',
        formatter: val => val && getCurrentTime(val)
      }, {
        label: '备注',
        prop: 'auditRemark'
      }]
    });
    const selectTableConfig = reactive({
      paginationConfig: usePageConfig(),
      data: [],
      isCardBlock: false,
      isShowHeader: false,
      name: ''
    });
    const selectColumnConfig = reactive({
      columnList: [{
        label: '影片名称',
        prop: 'name'
      }, {
        label: '剧集编号',
        prop: 'sequence',
        sortable: true,
        controller: () => {
          return props.detailInfo.programType === 'movie' ? false : true;
        }
      }, {
        label: '上传时间',
        prop: 'createTime',
        formatter: val => val && getCurrentTime(val)
      }]
    });

    const getDetailInfo = async (id, language) => {
      dramaOrMovieData.url = '';
      dramaOrMovieData.leftWarpLoading = true;

      try {
        //console.log('props.detailInfo.programType', props.detailInfo.programType)
        if (props.detailInfo.programType === 'movie') {
          // 拿对应的电影url数据
          let targetList = mediaList.value.filter(item => item.audioLanguage == language); // 根据语言找到对应的播放url

          tableConfig.data = targetList.length ? targetList[0].mediaContentList : [];
          dramaOrMovieData.url = targetList.length ? targetList[0].mediaContentList[0].playUrl : undefined;
        } else {
          // 电视剧数据
          let targetList = alltvEpisodesList.value ? alltvEpisodesList.value.filter(item => item.id == id) : []; // 左侧表单数据

          tableConfig.data = targetList.length ? targetList[0].mediaContentList : []; // 左侧播放链接

          dramaOrMovieData.url = targetList.length ? targetList[0].mediaContentList[0].playUrl : undefined; // 左侧字幕

          dramaOrMovieData.subtitleList = targetList.length ? targetList[0].subtitleList : [];
        }
      } catch (error) {
        console.log('601-err', error);
      }

      dramaOrMovieData.leftWarpLoading = false;
    }; // 季下拉选项改变事件


    const onSeasonChange = seasonId => {
      console.log('season', seasonId);
      dramaOrMovieData.currentSeasonId = seasonId; // 此处逻辑与712行相同
      // 右侧表格数据用对应seasonId的tvEpisodesList

      let targetList = Tags.value[dramaOrMovieData.currentActive].tvSeasonList.filter(item => item.id == dramaOrMovieData.currentSeasonId);
      let tvEpisodesList = targetList.length ? targetList[0].tvEpisodesList : [];
      dramaOrMovieData.name = tvEpisodesList.length ? tvEpisodesList[0].name : '';
      checkTableConfig.data = tvEpisodesList.length ? tvEpisodesList : [];
      checkTableConfig.paginationConfig.total = tvEpisodesList.length ? tvEpisodesList.length : 0; // 左侧字幕

      let currentSubtitleList = [];
      tvEpisodesList.forEach(item => {
        currentSubtitleList.push(...item.subtitleList);
      });
      dramaOrMovieData.subtitleList = currentSubtitleList; // 右侧表格默认激活第0项

      checkTableConfig.rowSelectIndex = 0; // 默认索引为0的TvEpisodesList的id

      let defaultTvEpisodesListId = tvEpisodesList[0] ? tvEpisodesList[0].id : undefined;
      getDetailInfo(defaultTvEpisodesListId, Tags.value[dramaOrMovieData.currentActive].audioLanguage);
    };

    const getTableList = async (isFirst, otherParams) => {
      //todo: otherParams点击右侧表格排序的时候会有排序参数，接口没有对应的排序功能
      checkTableConfig.rowSelectIndex = 0;
      dramaOrMovieData.anew = false;
      checkTableConfig.showLoading = true;
      const language = Tags.value.length > 0 && Tags.value[dramaOrMovieData.currentActive].language || '';
      let defaultLanguage = '';

      if (props.detailInfo.programType === 'movie') {
        try {
          // 影片的右侧列表请求
          const res = await getMovieInfoApi({
            movieId: props.detailInfo.id,
            infoType: 1
          });

          if (res.code == '0') {
            // 右侧tags
            Tags.value = res.data.map(item => {
              return {
                audioLanguage: item.audioLanguage
              };
            });
            defaultLanguage = Tags.value.length > 0 && Tags.value[dramaOrMovieData.currentActive].audioLanguage || ''; // 右侧表格数据用对应语言的mediaList

            let targetList = res.data ? res.data.filter(item => item.audioLanguage == defaultLanguage) : [];
            dramaOrMovieData.name = targetList.length ? targetList[0].name : '';
            checkTableConfig.data = targetList.length ? targetList : [];
            checkTableConfig.paginationConfig.total = targetList.length ? targetList.length : 0; // 记录全部的mediaList数据

            mediaList.value = res.data ? res.data : []; // 左侧字幕

            dramaOrMovieData.subtitleList = res.data[0].subtitleList;
          }

          checkTableConfig.data.length && getDetailInfo(props.detailInfo.id, defaultLanguage);

          if (!checkTableConfig.data.length) {
            dramaOrMovieData.subtitleList = [];
            tableConfig.data = [];
            dramaOrMovieData.url = '';
            handleDestroyVideo();
          }
        } catch (error) {
          console.log(error, '667-----');
        }
      } else {
        // 剧集的右侧列表请求
        try {
          const res = await getDramaInfoApi({
            tvSeriesId: props.detailInfo.id
          });

          if (res.code == '0') {
            // 右侧tags
            Tags.value = res.data.map(item => {
              return { ...item,
                audioLanguage: item.audioLanguage
              };
            });
            defaultLanguage = Tags.value.length > 0 && Tags.value[dramaOrMovieData.currentActive].audioLanguage || ''; // 季

            seasonOptions.value = Tags.value.length ? Tags.value[dramaOrMovieData.currentActive].tvSeasonList.map(item => {
              return { ...item,
                label: `Season ${item.sequence}`
              };
            }) : []; // 默认选取第一项

            dramaOrMovieData.currentSeasonId = seasonOptions.value.length ? seasonOptions.value[0].id : undefined; // 右侧表格数据用对应seasonId的tvEpisodesList 712行

            let targetList = Tags.value[dramaOrMovieData.currentActive].tvSeasonList.filter(item => item.id == dramaOrMovieData.currentSeasonId);
            let tvEpisodesList = targetList.length ? targetList[0].tvEpisodesList : [];
            dramaOrMovieData.name = tvEpisodesList.length ? tvEpisodesList[0].name : '';
            checkTableConfig.data = tvEpisodesList.length ? tvEpisodesList : [];
            checkTableConfig.paginationConfig.total = tvEpisodesList.length ? tvEpisodesList.length : 0; // 记录全部的tvSeasonMediaList数据

            res.data.forEach(tag => {
              tag.tvSeasonList.forEach(season => {
                // seasonId: 可根据此ID找到对应的右侧列表数据
                season.tvEpisodesList.forEach(episode => episode.seasonId = season.id);
                alltvEpisodesList.value.push(...season.tvEpisodesList);
              });
            }); // 左侧字幕

            let currentSubtitleList = [];
            tvEpisodesList.forEach(item => {
              currentSubtitleList.push(...item.subtitleList);
            });
            dramaOrMovieData.subtitleList = currentSubtitleList;

            if (isFirst && res.data.length > 0) {
              // 默认索引为0的TvEpisodesList的id
              let defaultTvEpisodesListId = tvEpisodesList[0] ? tvEpisodesList[0].id : undefined;
              getDetailInfo(defaultTvEpisodesListId, defaultLanguage);
            } else {
              res.data.length && getDetailInfo('', defaultLanguage);

              if (!checkTableConfig.data.length) {
                dramaOrMovieData.subtitleList = [];
                tableConfig.data = [];
                dramaOrMovieData.url = '';
                handleDestroyVideo();
              }
            }
          }
        } catch (error) {
          console.log('err-709', error);
        }
      }

      checkTableConfig.showLoading = false;
    };

    const handleSelectionChange = val => {
      selectTableConfig.data = JSON.parse(JSON.stringify(val));
    };

    const dramaOrMovieData = reactive({
      currentSubtitleIndex: 0,
      currentSeasonId: undefined,
      postData: {
        reason: ''
      },
      leftWarpLoading: false,
      rightWarpLoading: false,
      videoWarpLoading: false,
      currentActive: 0,
      subtitleList: [],
      name: '',
      url: '',
      auditStatus: -1,
      remark: '',
      anew: false,
      checked: false,
      ifReturn: false
    }); // 右侧审核列表table行点击事件

    const handleCheckTableRowClick = debounce((row, col, event) => {
      tableConfig.rowSelectIndex = 0;
      const language = Tags.value.length > 0 && Tags.value[dramaOrMovieData.currentActive].language || '';
      dramaOrMovieData.anew = false;
      checkTableConfig.rowSelectIndex = row.index;
      dramaOrMovieData.name = row.name;
      getDetailInfo(row.id, language);
    }, 500); // 字幕item点击事件

    const handleSubtitleItemClick = debounce(index => {
      dramaOrMovieData.currentSubtitleIndex = index;
    }, 500); // 重新审核按钮点击事件

    const handleAnew = () => {
      dramaOrMovieData.anew = true;
    }; // 表格排序


    const handleSortChange = debounce(async params => {
      tableConfig.rowSelectIndex = 0;
      checkTableConfig.rowSelectIndex = 0;

      if (params.order) {
        const sortType = params.order.replace('ending', '');
        getTableList(true, {
          sortType,
          sortByField: params.prop
        });
      } else {
        getTableList(true);
      }
    }, 500);

    const handleDestroyVideo = () => {
      // 销毁视频组件
      mediaPlayRef.value && mediaPlayRef.value.destroyVideo();
    }; // 复制URL


    const copyUrl = (url, event, className) => {
      if (className) {
        let target = document.querySelector('.' + className);
        const width = getTextWidth(target.innerText, {
          fontSize: '14px'
        });
        if (target.offsetWidth < width + 80) return;
      }

      handleCopy(url, event);
    }; //  内容超出时显示提示


    const tipDisabled = ref(false);

    const showTextTip = e => {
      const target = e.target;
      const width = getTextWidth(target.innerText, {
        fontSize: '14px'
      });
      tipDisabled.value = target.offsetWidth < width + 80;
    };

    const displayTextTip = () => {
      tipDisabled.value = false;
    };

    watch(() => props.modelValue, val => {
      if (val) {
        tableConfig.data = [];
        checkTableConfig.paginationConfig = usePageConfig();
        checkTableConfig.data = [];
        dramaOrMovieData.subtitleList = [];
        tableConfig.rowSelectIndex = 0;
        checkTableConfig.rowSelectIndex = 0;
        dramaOrMovieData.currentActive = 0;
        dramaOrMovieData.currentSubtitleIndex = 0;
        dramaOrMovieData.name = '';
        dramaOrMovieData.anew = false;
        getTableList(true);
        getAllLanguages();
        dramaOrMovieData.url = '';
      } else {
        selectTableConfig.data = [];
        Tags.value = [{}];
        handleDestroyVideo();
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(() => dialogConfig.visible, val => {
      if (resonFormRef.value) {
        resonFormRef.value.resetFields();
      }

      dramaOrMovieData.ifReturn = false;
    });
    watch(() => batchDialogConfig.visible, val => {
      if (batchTableRef.value) {
        batchTableRef.value.commonTableRef.clearSort();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_MPopper = _resolveComponent("MPopper");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form = _resolveComponent("el-form");

      const _component_MDialog = _resolveComponent("MDialog");

      const _directive_loading = _resolveDirective("loading");

      return __props.modelValue ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('影片内容审核')), 1), _createVNode(_component_el_button, {
        class: "cms-op-btn cms-op-btn-main",
        onClick: back
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('返回')), 1)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_withDirectives((_openBlock(), _createElementBlock("div", null, [_createVNode(MediaPlay, {
        style: {
          "width": "576px",
          "height": "328px"
        },
        url: dramaOrMovieData.url,
        ref_key: "mediaPlayRef",
        ref: mediaPlayRef
      }, null, 8, ["url"])])), [[_directive_loading, dramaOrMovieData.videoWarpLoading]]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('影片名称')) + ": ", 1), _createElementVNode("span", _hoisted_8, _toDisplayString(dramaOrMovieData.name), 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_common_table, {
        style: {
          "width": "100%"
        },
        showPagination: false,
        "table-config": tableConfig,
        rowSelectIndex: tableConfig.rowSelectIndex
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          cellSlot: _withCtx(scope => [scope.column.property == 'playUrl' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_MPopper, {
            disabled: tipDisabled.value,
            placement: "top",
            trigger: "hover"
          }, {
            reference: _withCtx(() => [_createElementVNode("div", {
              onMouseover: showTextTip,
              class: _normalizeClass('url-span-' + scope.row.index),
              style: {
                "display": "inline-block",
                "white-space": "nowrap",
                "width": "100%",
                "overflow": "hidden",
                "text-overflow": "ellipsis"
              }
            }, [_createElementVNode("span", null, _toDisplayString(scope.row.playUrl), 1), scope.row.playUrl ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onMouseover: _withModifiers(displayTextTip, ["stop"]),
              class: "cms-op-btn-non-focus",
              onClick: $event => copyUrl(scope.row.playUrl, $event, 'url-span-' + scope.row.index),
              style: {
                "width": "60px",
                "margin-left": "20px"
              }
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('复制')), 1)]),
              _: 2
            }, 1032, ["onMouseover", "onClick"])) : _createCommentVNode("", true)], 34)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", null, _toDisplayString(scope.row.playUrl), 1), _createVNode(_component_el_button, {
              class: "cms-op-btn-non-focus",
              onClick: $event => copyUrl(scope.row.playUrl, $event),
              style: {
                "margin-left": "20px"
              }
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('复制')), 1)]),
              _: 2
            }, 1032, ["onClick"])])]),
            _: 2
          }, 1032, ["disabled"])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "rowSelectIndex"]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('字幕')), 1), _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dramaOrMovieData.subtitleList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["subtitle-item", dramaOrMovieData.currentSubtitleIndex === index ? 'is-subtitle-select' : '']),
          key: index,
          onClick: $event => _unref(handleSubtitleItemClick)(index)
        }, _toDisplayString(item.language), 11, _hoisted_16);
      }), 128))])])]), __props.modelValue && checkTableConfig.data.length > 0 && (checkTableConfig.data[checkTableConfig.rowSelectIndex].releaseStatus === 'not_online' || dramaOrMovieData.anew) ? (_openBlock(), _createBlock(Buttons, {
        key: 0,
        class: "buttons",
        buttonsList: tableConfig.headerButtonsList
      }, null, 8, ["buttonsList"])) : _createCommentVNode("", true)])]), __props.modelValue && checkTableConfig.data.length > 0 && checkTableConfig.data[checkTableConfig.rowSelectIndex].releaseStatus !== 'not_online' && !dramaOrMovieData.anew ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "check-result",
        style: _normalizeStyle('background-color:' + (checkTableConfig.data[checkTableConfig.rowSelectIndex].releaseStatus === 'online' ? '#f5faf8' : ''))
      }, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('上线状态')) + ":", 1), _createElementVNode("span", {
        class: "error-text",
        style: _normalizeStyle('color:' + (checkTableConfig.data[checkTableConfig.rowSelectIndex].releaseStatus === 'online' ? '#3aaf81' : ''))
      }, _toDisplayString(_unref(RELEASE_STATUS_NEW)[checkTableConfig.data[checkTableConfig.rowSelectIndex].releaseStatus]), 5)]), __props.modelValue && checkTableConfig.data[checkTableConfig.rowSelectIndex].releaseStatus === 'offline' ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('原因')) + ":", 1), _createElementVNode("span", null, _toDisplayString(checkTableConfig.data[checkTableConfig.rowSelectIndex].offlineReason), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_20, [_createVNode(_component_el_button, {
        onClick: handleAnew,
        class: "green-btn cms-op-btn cms-op-btn-main"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('重新审核')), 1)]),
        _: 1
      })])], 4)) : _createCommentVNode("", true)])), [[_directive_loading, dramaOrMovieData.leftWarpLoading]]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(TagType, {
        modelValue: Tags.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => Tags.value = $event),
        onOnTagClick: _unref(onTagClick),
        "current-active": dramaOrMovieData.currentActive,
        "show-add-button": false,
        languageOptions: languageOptions.value
      }, null, 8, ["modelValue", "onOnTagClick", "current-active", "languageOptions"]), _createElementVNode("div", _hoisted_22, [_createVNode(Buttons, {
        class: "buttons",
        buttonsList: checkTableConfig.headerButtonsList
      }, null, 8, ["buttonsList"]), __props.detailInfo.programType === 'tv_series' ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 0,
        label: _ctx.$t('选择季'),
        style: {
          "width": "240px",
          "margin-bottom": "10px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: dramaOrMovieData.currentSeasonId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dramaOrMovieData.currentSeasonId = $event),
          filterable: "",
          placeholder: "Select",
          size: "large",
          onChange: onSeasonChange
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seasonOptions.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.label,
              value: item.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"])) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createBlock(_component_common_table, {
        ref_key: "checkTableRef",
        ref: checkTableRef,
        onSelectionChange: handleSelectionChange,
        onRowClick: _unref(handleCheckTableRowClick),
        onSortChange: _unref(handleSortChange),
        rowSelectIndex: checkTableConfig.rowSelectIndex,
        style: {
          "width": "100%"
        },
        "table-config": checkTableConfig,
        "pagination-config": checkTableConfig.paginationConfig,
        render: () => getTableList(false)
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": checkColumnConfig.columnList
        }, {
          cellSlot: _withCtx(scope => [_createElementVNode("div", {
            style: _normalizeStyle('color:' + _unref(RELEASE_COLOR_NEW)[scope.row.releaseStatus])
          }, _toDisplayString(_unref(RELEASE_STATUS_NEW)[scope.row.releaseStatus]), 5)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["onRowClick", "onSortChange", "rowSelectIndex", "table-config", "pagination-config", "render"])), [[_directive_loading, checkTableConfig.showLoading]])])])), [[_directive_loading, dramaOrMovieData.rightWarpLoading]])]), _createVNode(_component_MDialog, {
        autoLoading: "",
        modelValue: dialogConfig.visible,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => dialogConfig.visible = $event),
        nativeConfig: {
          width: '25%',
          top: '20vw'
        },
        dialogConfig: dialogConfig.config,
        onOnConfirm: dialogConfig.confirm
      }, {
        default: _withCtx(() => [dialogConfig.action === 'offline' ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t('确认将影片修改为下线吗?')), 1), _createVNode(_component_el_checkbox, {
          modelValue: dramaOrMovieData.ifReturn,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dramaOrMovieData.ifReturn = $event),
          label: _ctx.$t('直接退回审核修改'),
          size: "large"
        }, null, 8, ["modelValue", "label"]), _createVNode(_component_el_form, {
          model: dramaOrMovieData.postData,
          ref_key: "resonFormRef",
          ref: resonFormRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "reason",
            rules: [{
              validator: validatorReason,
              trigger: 'blur'
            }, {
              max: 100,
              message: _ctx.$t('限制字符数量', {
                num: '100'
              }),
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              style: {
                "width": "100%"
              },
              placeholder: _ctx.$t('请输入下线原因'),
              maxlength: 100,
              modelValue: dramaOrMovieData.postData.reason,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dramaOrMovieData.postData.reason = $event),
              "show-word-limit": "",
              type: "textarea"
            }, null, 8, ["placeholder", "modelValue"])]),
            _: 1
          }, 8, ["rules"])]),
          _: 1
        }, 8, ["model"])])) : _createCommentVNode("", true), dialogConfig.action === 'online' ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('确认将影片修改为上线吗?')), 1)])) : _createCommentVNode("", true), dialogConfig.action === 'return' ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('确认将影片修改为退回审核吗?')), 1)])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"]), _createVNode(_component_MDialog, {
        autoLoading: "",
        modelValue: batchDialogConfig.visible,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => batchDialogConfig.visible = $event),
        dialogConfig: batchDialogConfig.config,
        onOnConfirm: batchDialogConfig.confirm
      }, {
        default: _withCtx(() => [batchDialogConfig.action === 'offline' ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t('确认将影片修改为下线吗?')), 1), _createVNode(_component_el_checkbox, {
          modelValue: dramaOrMovieData.ifReturn,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => dramaOrMovieData.ifReturn = $event),
          label: _ctx.$t('直接退回审核修改'),
          size: "large"
        }, null, 8, ["modelValue", "label"]), _createVNode(_component_el_form, {
          model: dramaOrMovieData.postData,
          ref_key: "resonFormRef",
          ref: resonFormRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "reason",
            rules: [{
              validator: validatorReason,
              trigger: 'blur'
            }, {
              max: 100,
              message: _ctx.$t('限制字符数量', {
                num: '100'
              }),
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              style: {
                "width": "100%"
              },
              placeholder: _ctx.$t('请输入下线原因'),
              maxlength: 100,
              modelValue: dramaOrMovieData.postData.reason,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => dramaOrMovieData.postData.reason = $event),
              "show-word-limit": "",
              type: "textarea"
            }, null, 8, ["placeholder", "modelValue"])]),
            _: 1
          }, 8, ["rules"])]),
          _: 1
        }, 8, ["model"])])) : _createCommentVNode("", true), batchDialogConfig.action === 'online' ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('确认将影片修改为上线吗?')), 1)])) : _createCommentVNode("", true), batchDialogConfig.action === 'return' ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('确认将影片修改为退回审核吗?')), 1)])) : _createCommentVNode("", true), _createVNode(_component_common_table, {
          ref_key: "batchTableRef",
          ref: batchTableRef,
          style: {
            "width": "100%"
          },
          showPagination: false,
          "table-config": selectTableConfig
        }, {
          default: _withCtx(() => [_createVNode(_component_column, {
            "column-list": selectColumnConfig.columnList
          }, null, 8, ["column-list"])]),
          _: 1
        }, 8, ["table-config"])]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"])])) : _createCommentVNode("", true);
    };
  }

});